@if (tags?.length) {
  <div class="flex flex-wrap gap-x-4 gap-y-1">
    @for (tag of tags; track tag.tag) {
      <app-tag-component [tag]="tag" />
    }
  </div>
}
